"use client";

import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Play } from "lucide-react";

interface DemoTagProps {
    isVisible: boolean;
    onClick: () => void;
}

export default function DemoTag({ isVisible, onClick }: DemoTagProps) {
    return (
        <AnimatePresence>
            {isVisible && (
                <motion.button
                    initial={{ x: 100, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: 100, opacity: 0 }}
                    whileHover={{ x: -4, scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={onClick}
                    className="fixed right-0 top-1/2 -translate-y-1/2 z-[45] flex items-center gap-2 px-3 py-6 bg-[var(--md-sys-color-primary-container)] text-[var(--md-sys-color-on-primary-container)] border border-[var(--md-sys-color-primary)]/20 shadow-cinematic-2 rounded-l-2xl hover:bg-[var(--md-sys-color-primary)] hover:text-[var(--md-sys-color-on-primary)] transition-colors group cursor-pointer"
                    aria-label="Re-watch Video Demo"
                >
                    <div className="flex flex-col items-center gap-4">
                        <motion.div 
                            animate={{ scale: [1, 1.2, 1] }} 
                            transition={{ duration: 2, repeat: Infinity }}
                            className="w-8 h-8 rounded-full bg-[var(--md-sys-color-primary)] text-white flex items-center justify-center shadow-sm group-hover:bg-white group-hover:text-[var(--md-sys-color-primary)]"
                        >
                            <Play fill="currentColor" className="w-4 h-4 ml-0.5" />
                        </motion.div>
                        
                        <span 
                            className="text-[10px] font-black uppercase tracking-[0.2em] [writing-mode:vertical-rl] whitespace-nowrap opacity-80 group-hover:opacity-100"
                        >
                            Watch Demo
                        </span>
                    </div>

                    {/* Aesthetic Glow (M3 specific) */}
                    <div className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 rounded-l-2xl transition-opacity pointer-events-none" />
                </motion.button>
            )}
        </AnimatePresence>
    );
}
